import { iterLines, tokens } from './lexer.js';
export function parseSgfam(content) {
    const rows = [];
    const unparsed = [];
    for (const line of iterLines(content)) {
        // Strip `;` comments. SGFAM files never use `;` as a record leader.
        const semi = line.trimmed.indexOf(';');
        const body = (semi === -1 ? line.trimmed : line.trimmed.slice(0, semi)).trim();
        if (body === '')
            continue;
        const parts = tokens(body);
        if (parts.length < 5 || parts[0] !== 'S') {
            unparsed.push({
                lineNo: line.lineNo,
                raw: line.raw,
                reason: parts[0] !== 'S' ? `expected leading 'S', got '${parts[0] ?? '(empty)'}'` : 'too few columns',
            });
            continue;
        }
        const [, sgName, cabd, sgbd, zcsStr, faStr, ...rest] = parts;
        const zcs = Number(zcsStr);
        const fa = Number(faStr);
        if (!Number.isInteger(zcs) || !Number.isInteger(fa)) {
            unparsed.push({
                lineNo: line.lineNo,
                raw: line.raw,
                reason: `ZCS/FA columns must be integers, got '${zcsStr}'/'${faStr}'`,
            });
            continue;
        }
        rows.push({
            sgName: sgName,
            cabd: cabd,
            sgbd: sgbd,
            zcs,
            fa,
            comment: rest.join(' '),
        });
    }
    return { rows, unparsed };
}
//# sourceMappingURL=sgfam.js.map